import { createAction } from 'redux-actions';
import { UNSHIFT_SEAT } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/actionTypes';

export default createAction(UNSHIFT_SEAT);
